import { ApolloProvider } from '@apollo/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { config } from '~root/src/config';
import { App } from './App';
import { queryClient } from './api/utils/reactQueryClient';
import { apolloClient } from './apollo/apollo-client';
import { AppContextProvider } from './contexts/AppContextProvider';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <ApolloProvider client={apolloClient}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppContextProvider config={config} apolloClient={apolloClient}>
          <App />

          <ReactQueryDevtools initialIsOpen={false} />
        </AppContextProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ApolloProvider>
);
